const XS_MIN = 0;
const SM_MIN = 480;
const MD_MIN = 768;
const LG_MIN = 992;

const XS_MAX = SM_MIN - 1;
const SM_MAX = MD_MIN - 1;
const MD_MAX = LG_MIN - 1;
const LG_MAX = Infinity;

export default {
  XS_MIN,
  XS_MAX,
  SM_MIN,
  SM_MAX,
  MD_MIN,
  MD_MAX,
  LG_MIN,
  LG_MAX
};
